export const BankerConstant = {
    CATEGORY: "Code",
    TITLE: "Banker",
    BANK_CODE: "Bank Code",
    BANK_NAME: "Bank Name",
    BANK_AC_NO: "Bank A/C No.",
    BANK_AC_CURRENCY: "Bank A/C Currency",
    BANK_CONTACT_PERSON: "Bank Contact Person",
    CONTACT_NO: "Contact No.",
    BANK_ADDRESS_LINE_1: "Bank Address Line 1",
    BANK_ADDRESS_LINE_2: "Bank Address Line 2",
    BANK_ADDRESS_LINE_3: "Bank Address Line 3",
    BANK_ADDRESS_LINE_4: "Bank Address Line 4",
    BANK_ADDRESS_LINE_5: "Bank Address Line 5",
    CREATED_BY: "Created By",
    CREATED_DATE: "Created Date",
    LAST_UPDATED_BY: "Last Updated By",
    LAST_UPDATED_DATE: "Last Updated Date",
    ACTIVE_IND: "Active Ind",
}
export const BankerRequiredFieldList: string[] = [
    'bankCode',
    'bankName',
    'bankAcNo',
    'bankAcCurrency',
    'bankAddressLine1',
    'activeInd',
];
